import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AllReviewsComponentDef } from '@df/catalog-ui/review/all-reviews.component.def';
import { RatingComponent } from '../../../../ui/common/rating.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ReviewsPagerComponent } from '../../../../ui/display/reviews-pager.component';

@Component({
    selector: 'all-reviews',
    templateUrl: './all-reviews.html',
    styleUrl: './all-reviews.scss',
    standalone: true,
    imports: [CommonModule, RatingComponent, ReviewsPagerComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllReviewsComponent extends AllReviewsComponentDef {}
